import { Component, Input, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormControl, ReactiveFormsModule } from "@angular/forms";

@Component({
  selector: "keus-password-requirements",
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  template: `
    <span [style.color]="invalidColor" class="text-[0.8125rem] font-normal">
      La password deve contenere:
    </span>
    <ul class="mt-2 text-[0.8125rem] space-y-1">
      <li
        *ngFor="let rule of rules"
        [style.color]="rule.valid ? validColor : invalidColor"
        class="flex items-center gap-2 text-[0.8125rem] font-normal"
      >
        • {{ rule.label }}
      </li>
    </ul>
  `,
})
export class PasswordRequirementsComponent implements OnInit {
  /** Form control from parent */
  @Input({ required: true }) public control!: FormControl<string>;

  /** Color when the rule is valid */
  public readonly validColor = "#059669";

  /** Color when the rule is invalid */
  public readonly invalidColor = "#71717A";

  /** Reactive list of rules */
  public rules: { label: string; valid: boolean }[] = [];

  /**
   * Initializes rules and sets up reactive tracking
   */
  ngOnInit(): void {
    this.rules = [
      { label: "8 caratteri", valid: false },
      { label: "1 carattere speciale", valid: false },
      { label: "1 numero", valid: false },
      { label: "1 lettera maiuscola", valid: false },
      { label: "1 lettera minuscola", valid: false },
    ];

    this.control.valueChanges.subscribe((value) => {
      const val = value ?? "";
      this.rules = [
        { label: "8 caratteri", valid: val.length >= 8 },
        { label: "1 carattere speciale", valid: /[^A-Za-z0-9]/.test(val) },
        { label: "1 numero", valid: /[0-9]/.test(val) },
        { label: "1 lettera maiuscola", valid: /[A-Z]/.test(val) },
        { label: "1 lettera minuscola", valid: /[a-z]/.test(val) },
      ];
    });
  }
}
